import { SystemRolesOverviewTable } from "./Components/SystemRolesOverviewTable";

interface SystemRolesOverviewProps {
  prGroupId?: string;
}

export const SystemRolesOverview = ({ prGroupId }: SystemRolesOverviewProps) => {
  return (
    <div className="g-card">
      <SystemRolesOverviewTable prGroupId={prGroupId} />
    </div>
  );
};
